import { render, staticRenderFns } from "./FormInputResidentStatusRadio.vue?vue&type=template&id=3ad5e7ef&scoped=true&lang=pug"
import script from "./FormInputResidentStatusRadio.vue?vue&type=script&lang=ts"
export * from "./FormInputResidentStatusRadio.vue?vue&type=script&lang=ts"
import style0 from "./FormInputResidentStatusRadio.vue?vue&type=style&index=0&id=3ad5e7ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad5e7ef",
  null
  
)

export default component.exports